module.exports = __webpack_public_path__ + "img/nadia_medina.1c1eba94.png";